import React from 'react';

/**
 * "Soon" pill for features that are planned but not built.
 *
 * Ported from the landing page's .soon-tag (landing/style.css:1000) so the two
 * surfaces read as one product. Same rule applies here as there: never present
 * an unshipped feature as live — tag it and make it non-interactive.
 *
 * Pair with `disabled` + `aria-disabled` on the control itself and drop the
 * cursor-pointer / hover animation, or the tag says "soon" while the affordance
 * still says "tap me".
 *
 * `label` exists for areas that ARE reachable but only show sample content —
 * "Preview" rather than "Soon", because "Soon" on a page you can open right now
 * reads as "don't bother". Explore's mentorship card uses it; that page is
 * demoed live and its navigation must never be removed.
 *
 * `onDark` is for the green mobile headers. The coral tint is translucent, so
 * over brand-primary it composites to nearly the text colour — measured 1.05:1,
 * i.e. invisible. A solid white ground keeps the same coral text at 5.13:1.
 */
const SoonTag = ({ className = '', label = 'Soon', onDark = false }) => (
  <span
    className={`inline-block flex-shrink-0 align-middle rounded-full font-bold uppercase ${className}`}
    style={{
      fontSize: '0.625rem',
      letterSpacing: '0.06em',
      // accent-text, not accent: the coral measured 2.60:1 on its own tint
      color: 'var(--brand-accent-text)',
      backgroundColor: onDark ? '#FFFFFF' : 'rgba(224,122,95,0.12)',
      padding: '0.15rem 0.5rem',
    }}
  >
    {label}
  </span>
);

export default SoonTag;
